module.exports = __webpack_public_path__ + "img/activity5.dc5bbeae.png";